import React from "react";
import useNavigator from "../../hooks/useNavigator";
import Logo from "../../assets/images/logo.png";
import GradingIcon from "../../assets/icons/GradingIcon";
import DetailsIcon from "../../assets/icons/DetailsIcon";
import Off from "../../assets/icons/off.svg";
import {
  SidenavWrapper,
  ImageWrapper,
  NavItem,
  StyledLink,
  LogoutBtn,
  Name,
  LogoutBox,
  SidenavLogo,
} from "./Sidenav.styles";
import { useAuth } from "../../contexts/AuthContext";

function Sidenav() {
  const navigator = useNavigator();
  const auth = useAuth();

  const myRoutes = [
    {
      displayName: "Clinic Details",
      path: "/tmrw-admin/clinic-details",
      icon: DetailsIcon,
    },
    {
      displayName: "Gradings",
      path: "/tmrw-admin/gradings",
      icon: GradingIcon,
    },
  ];

  const isActive = (activePath: string): boolean => {
    const pathName = window.location.href;
    return pathName.includes(activePath);
  };

  const getFullName = () => {
    return auth?.user?.data?.firstName + " " + auth?.user?.data?.lastName;
  };

  return (
    <SidenavWrapper>
      <ImageWrapper onClick={() => navigator("/tmrw-admin/clinic-details")}>
        <SidenavLogo src={Logo} alt="logo" />
      </ImageWrapper>

      <div>
        {myRoutes.map(({ displayName, icon: Icon, path }) => (
          <NavItem onClick={() => navigator(path)} key={path}>
            <div className="icon">
              <Icon
                fill={isActive(path) ? "#F8D347" : "rgba(255, 255, 255, 0.6)"}
                height="22"
                width="22"
              />
            </div>
            <StyledLink active={isActive(path)}>{displayName}</StyledLink>
          </NavItem>
        ))}
        <LogoutBox>
          <Name>{getFullName()}</Name>

          <NavItem style={{ marginTop: "10px" }}>
            <div onClick={auth?.logout} className="icon">
              <img src={Off} alt="logout" />
            </div>
            <LogoutBtn onClick={auth?.logout}>Logout</LogoutBtn>
          </NavItem>
        </LogoutBox>
      </div>
    </SidenavWrapper>
  );
}

export default Sidenav;
